import { useEffect, useState } from "react";
import SmoothScroll from "@/components/SmoothScroll";
import SEO, { organizationSchema, localBusinessSchema, websiteSchema, faqSchema, productListSchema } from "@/components/SEO";
import { BrochureGateProvider } from "@/components/BrochureGate";
import Navbar from "@/components/Navbar";
import PromoBanner from "@/components/PromoBanner";
import Hero from "@/components/Hero";
import TrustMetrics from "@/components/TrustMetrics";
import ProductCategories from "@/components/ProductCategories";
import Manufacturing from "@/components/Manufacturing";
import WhyChoose from "@/components/WhyChoose";
import Offers from "@/components/Offers";
import BestSellers from "@/components/BestSellers";
import Process from "@/components/Process";
import Testimonials from "@/components/Testimonials";
import ExportPresence from "@/components/ExportPresence";
import FAQ, { FAQS } from "@/components/FAQ";
import FranchiseForm from "@/components/FranchiseForm";
import Footer from "@/components/Footer";
import FloatingWidgets from "@/components/FloatingWidgets";
import api from "@/lib/api";

export default function HomePage() {
  const [products, setProducts] = useState([]);
  useEffect(() => {
    api.get("/products").then(({ data }) => setProducts(data.products || [])).catch(() => {});
  }, []);

  const jsonLd = [
    organizationSchema(),
    localBusinessSchema(),
    websiteSchema(),
    faqSchema(FAQS),
    ...(products.length ? [productListSchema(products)] : []),
  ];

  return (
    <SmoothScroll>
      <SEO
        title="Saans Wellness — Ayurvedic & Nutraceutical PCD Franchise & Manufacturing"
        description="Start your Ayurvedic & nutraceutical PCD franchise with Saans Wellness — monopoly rights, high margins, free marketing support and WHO-GMP manufacturing. Breathe Better. Live Better."
        path="/"
        jsonLd={jsonLd}
      />
      <BrochureGateProvider>
        <div className="min-h-screen bg-[#f9f8f5] text-[#202124]" data-testid="home-page">
          <PromoBanner />
          <Navbar />
          <main>
            <Hero />
            <TrustMetrics />
            <ProductCategories />
            <Manufacturing />
            <WhyChoose />
            <Offers />
            <BestSellers />
            <Process />
            <Testimonials />
            <ExportPresence />
            <FAQ />
            <FranchiseForm />
          </main>
          <Footer />
          <FloatingWidgets />
        </div>
      </BrochureGateProvider>
    </SmoothScroll>
  );
}
